module.exports = __webpack_public_path__ + "img/logo_rojo.6aba7e90.png";